var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row px-1 h-100" }, [
    _c("div", { staticClass: "col-12 bg-gray2 text-center" }, [
      _c("div", { staticClass: "pb-1" }, [
        _c("img", {
          class: _vm.shopSosh
            ? "filter-gray3 illustration-height"
            : "illustration-height",
          attrs: { src: _vm.dto.imageUrl, alt: "" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pb-2" }, [
        _c(
          "h4",
          {
            staticClass: "text-gray3 mb-0",
            staticStyle: { "max-width": "inherit" },
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.dto.title) + "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "lead text-gray3 mb-0" }, [
          _vm._v(_vm._s(_vm.dto.subtitle)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mx-auto justify-content-center" }, [
      _c("div", { staticClass: "col-12 col-md-6 col-lg-4 p-1" }, [
        _c("div", {}, [
          _c(
            "a",
            {
              staticClass: "ob1-card ob1-card-link card-width bg-white p-1",
              attrs: {
                href: _vm.dto.ctaMobile.actionUrl,
                "data-oevent-category": _vm.dto.ctaMobile.tmsData.category,
                "data-oevent-action": _vm.dto.ctaMobile.tmsData.action,
                "data-oevent-label": _vm.dto.ctaMobile.tmsData.label,
              },
            },
            [
              _c("div", [
                _c("p", { staticClass: "d-flex align-items-center mb-0" }, [
                  _c("img", {
                    attrs: {
                      height: "66",
                      src: _vm.dto.ctaMobile.imageUrl,
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fw-bold ms-1 ms-md-2" }, [
                    _vm._v(_vm._s(_vm.dto.ctaMobile.label)),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 col-lg-4 p-1" }, [
        _c("div", {}, [
          _c(
            "a",
            {
              staticClass: "ob1-card ob1-card-link card-width bg-white p-1",
              attrs: {
                href: _vm.dto.ctaInternet.actionUrl,
                "data-oevent-category": _vm.dto.ctaInternet.tmsData.category,
                "data-oevent-action": _vm.dto.ctaInternet.tmsData.action,
                "data-oevent-label": _vm.dto.ctaInternet.tmsData.label,
              },
            },
            [
              _c("div", [
                _c("p", { staticClass: "d-flex align-items-center mb-0" }, [
                  _c("img", {
                    attrs: {
                      height: "66",
                      src: _vm.dto.ctaInternet.imageUrl,
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fw-bold ms-1 ms-md-2" }, [
                    _vm._v(_vm._s(_vm.dto.ctaInternet.label)),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 col-lg-4 p-1" }, [
        _c("div", {}, [
          _c(
            "a",
            {
              staticClass: "ob1-card ob1-card-link card-width bg-white p-1",
              attrs: {
                href: _vm.dto.ctaTerminal.actionUrl,
                "data-oevent-category": _vm.dto.ctaTerminal.tmsData.category,
                "data-oevent-action": _vm.dto.ctaTerminal.tmsData.action,
                "data-oevent-label": _vm.dto.ctaTerminal.tmsData.label,
              },
            },
            [
              _c("div", [
                _c("p", { staticClass: "d-flex align-items-center mb-0" }, [
                  _c("img", {
                    attrs: {
                      height: "66",
                      src: _vm.dto.ctaTerminal.imageUrl,
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fw-bold ms-1 ms-md-2" }, [
                    _vm._v(_vm._s(_vm.dto.ctaTerminal.label)),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }